module.exports = __webpack_public_path__ + "static/media/hands-usd.2a12e0d1.svg";